<template>
  <el-dialog
      title="报告详情"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleClose"
      class="preview-report-dialog"
  >
    <div v-if="currentClass">
      <el-descriptions :column="1" border size="medium">
        <el-descriptions-item :label="nameLabel">
          <span style="font-weight: bold;">{{ displayName }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="报告名称">
          <span>{{ getFileName(displayDZ) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="报告状态">
          <el-tag type="success" size="small">已上传</el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 文件预览区域 -->
      <div class="file-preview">
        <i class="el-icon-document file-icon"></i>
        <div class="file-name">{{ getFileName(displayDZ) }}</div>
        <div class="file-hint">点击下方按钮进行下载</div>
      </div>

      <div class="button-group">
        <el-button
            type="primary"
            @click="handleDownload"
            icon="el-icon-download"
            size="medium"
        >
          下载报告
        </el-button>
        <!--        <el-button-->
        <!--            type="danger"-->
        <!--            @click="handleDelete"-->
        <!--            icon="el-icon-delete"-->
        <!--            size="medium"-->
        <!--        >-->
        <!--          删除报告-->
        <!--        </el-button>-->
      </div>
    </div>
  </el-dialog>
</template>

<script>
// import {deleteReportApi} from '@/api/teacher'

export default {
  name: 'PreviewReportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentClass: {
      type: Object,
      default: () => ({})
    },
    currentStudents: {
      type: Object,
      default: () => ({})
    },
    tabType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      deleting: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal
      }
    }
  },
  computed: {
    displayName() {
      if (this.tabType === 'students') {
        return this.currentStudents ? this.currentStudents.xsxm : ''
      } else {
        return this.currentClass ? this.currentClass.bjmc : ''
      }
    },
    displayDZ() {
      if (this.tabType === 'students') {
        return this.currentStudents ? this.currentStudents.bgdz : ''
      } else {
        return this.currentClass ? this.currentClass.bgdz : ''
      }
    },
    nameLabel() {
      return this.tabType === 'students' ? '学生姓名' : '班级名称';
    },

  },
  methods: {
    getFileName(url) {
      if (!url) return '';
      // 提取文件名
      const fullFileName = url.split('/').pop();
      const fileNameWithoutExt = fullFileName.split('_')[0];

      return fileNameWithoutExt;
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    // 下载报告
    handleDownload() {
      if (this.tabType === 'students') {

        if (!this.currentStudents.bgdz) {
          this.$message.error('报告文件不存在')
          return
        }

        const link = document.createElement('a')
        link.href = this.currentStudents.bgdz
        link.target = '_blank'

        const fileName = `班级报告_${this.currentStudents.bjmc}_${new Date().getTime()}.docx`
        link.download = fileName

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$message.success('开始下载报告')
      } else {


        if (!this.currentClass.bgdz) {
          this.$message.error('报告文件不存在')
          return
        }

        const link = document.createElement('a')
        link.href = this.currentClass.bgdz
        link.target = '_blank'

        const fileName = `班级报告_${this.currentClass.bjmc}_${new Date().getTime()}.docx`
        link.download = fileName

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$message.success('开始下载报告')
      }

    },

    // 删除报告
    handleDelete() {
      this.$confirm('确定要删除该报告吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            this.executeDelete().finally(() => {
              instance.confirmButtonLoading = false
              done()
            })
          } else {
            done()
          }
        }
      }).then(() => {
      }).catch(() => {
      })
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.file-preview {
  margin-top: 30px;
  text-align: center;
  padding: 30px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;

  .file-icon {
    font-size: 60px;
    color: #409EFF;
    margin-bottom: 15px;
  }

  .file-name {
    font-size: 16px;
    color: #303133;
    margin-bottom: 10px;
    word-break: break-all;
  }

  .file-hint {
    color: #909399;
    font-size: 14px;
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;
}
</style>

<style lang="scss">
.preview-report-dialog {
  .el-descriptions__body {
    background-color: #fff;
  }

  .el-descriptions-item__label {
    width: 100px;
    background-color: #f5f7fa;
  }
}
</style>
